import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import Editor from "ckeditor5-custom-build";


const TextEditor = ({ description, setDescription, name, setForm, form }) => {
  // const [editorData, setEditorData] = useState('<p>Start typing...</p>');

  const [text,setText] = useState('');

  useEffect(()=>{
     if(description)
     {
      setText(description);
     }
  },[description])



  return (
    <div>
      <CKEditor
        editor={ClassicEditor}
        data={text}
        onReady={(editor) => {
          console.log("Editor is ready to use!", editor);
        }}
        config={{
          toolbar: [
            "heading",
            "|",
            "bold",
            "italic",
            // "underline",
            "bulletedList",
            "numberedList",
            "insertTable",
            "undo",
            "redo",
            "link",
          ],
          table: {
            contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
          },
            link: {
            decorators: {
              openInNewTab: {
                mode: "manual",
                label: "Open in a new tab",
                defaultValue: true,
                attributes: {
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
              },
            },
          },
          // plugins: [Underline],
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          console.log({ event, editor, data });
          setDescription && setDescription(data);
          setForm && setForm({ ...form, [name]: data });
        }}
        onBlur={(event, editor) => {
          console.log("Blur.", editor);
        }}
        onFocus={(event, editor) => {
          console.log("Focus.", editor);
        }}
      />
    </div>
  );
};

export default TextEditor;
